import { render } from "./CompanyQRAttendance.vue?vue&type=template&id=c90828b8"
import script from "./CompanyQRAttendance.vue?vue&type=script&lang=js"
export * from "./CompanyQRAttendance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__